import { Button } from '@/components/ui/button';
import { PDKMenuIcon } from '@/components/ui/pdk-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

const TradeMenuButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" className="p-1 h-fit" onClick={onClick}>
          <PDKMenuIcon className={cn('h-3.5 w-3.5 cursor-pointer', {})} />
        </Button>
      </TooltipTrigger>
      <TooltipContent className="flex flex-row gap-1 items-center">
        Trade Actions Menu (Not Implemented)
        {/* <KeyboardKeyIcon>{HOTKEYS.TRADE_IN_APPRAISAL_MENU}</KeyboardKeyIcon> */}
      </TooltipContent>
    </Tooltip>
  );
};

export default TradeMenuButton;
